import { ArrowRightIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface SourceEmptyStateProps {
  isLoadingSources: boolean;
  hasAnyAvailableSources: boolean;
  isReadonly: boolean;
  onChooseSource: () => void;
}

const SourceEmptyState = ({
  isLoadingSources,
  hasAnyAvailableSources,
  isReadonly,
  onChooseSource,
}: SourceEmptyStateProps) => {
  if (isLoadingSources) {
    return (
      <div
        className={cn(
          "h-[46px] animate-pulse rounded-md border border-dashed border-muted-foreground/20",
          "bg-muted/20",
        )}
        aria-hidden
      />
    );
  }

  if (hasAnyAvailableSources) {
    return (
      <Button
        type="button"
        variant="outline"
        onClick={onChooseSource}
        disabled={isReadonly}
        className={cn(
          "group h-auto w-full justify-between gap-3 rounded-md border-dashed",
          "bg-background px-3 py-3 text-sm font-normal text-muted-foreground",
          "hover:border-solid hover:bg-muted/50 hover:text-foreground",
        )}
      >
        <span className="truncate">Choose a source column</span>
        <ArrowRightIcon
          className={cn(
            "h-4 w-4 flex-shrink-0 text-muted-foreground/50 transition-transform",
            "group-hover:translate-x-0.5 group-hover:text-foreground",
          )}
          aria-hidden
        />
      </Button>
    );
  }

  return (
    <div
      className={cn(
        "rounded-md border border-dashed border-muted-foreground/30",
        "bg-muted/30 px-3 py-3 text-sm text-muted-foreground",
      )}
    >
      No other sheets are available yet. Create another sheet or table to pull values from.
    </div>
  );
};

export default SourceEmptyState;
